module.exports = __webpack_public_path__ + "static/media/article1.a093f770.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/articles/article1.jpeg
// module id = 90
// module chunks = 0